import useApiClient from './api-client'
import type {
  NicedayOrderCreateOrderReq,
  NicedayOrderCreateOrderResData,
  NicedayOrderOrderStatusData,
  ForderCancelRuleRespData,
  ForderLeaveReviewReq,
  OrderDetailData,
  OrdersListResponse,
  EdbOrdersStatus as ApiEdbOrdersStatus,
} from '@/types/api'
import type { GetOrdersReqParams } from '@/types/order'

export const createOrder = async (params: NicedayOrderCreateOrderReq) => {
  const api = useApiClient<NicedayOrderCreateOrderResData>()
  const result = await api('/order', { method: 'POST', body: params })

  return result
}

export const releaseOrder = async (orderId: number | string) => {
  const api = useApiClient<NicedayOrderCreateOrderResData>()
  await api(`/order/${orderId}/release`, { method: 'DELETE' })

  return true
}

export const getOrderStatus = async (orderId: number) => {
  const api = useApiClient<NicedayOrderOrderStatusData>()
  const result = await api(`/order/${orderId}/status`)

  return result.data.status as ApiEdbOrdersStatus
}

export const getOrders = async (params: GetOrdersReqParams) => {
  const api = useApiClient<OrdersListResponse[]>()
  const result = await api(`/order`, { query: params })

  return result
}

export const getOrderInfo = async (orderId: string) => {
  const api = useApiClient<OrderDetailData>()
  const result = await api(`/order/${orderId}`)

  return result
}

export const getOrderCancelRule = async (orderId: number) => {
  const api = useApiClient<ForderCancelRuleRespData>()
  const result = await api(`/order/${orderId}/cancel-rule`)

  return result
}

export const postOrderCancel = async (orderId: number, reason: string) => {
  const api = useApiClient()
  const result = await api(`/order/${orderId}/cancel`, { method: 'POST', body: { reason } })

  return result
}

export const postOrderReview = async (orderId: number, payload: ForderLeaveReviewReq) => {
  const api = useApiClient()
  const result = await api(`/order/${orderId}/review`, { method: 'POST', body: payload })

  return result
}
